// CORE product data (Itanta Core — from official pricing brochure USD 2026)

export const CORE_TIERS = [
  {
    id: 'start',
    label: 'Entry',
    name: 'Itanta Start',
    price: 750,
    amcRate: 0.2,
    amcAmount: 150,
    tags: 256,
    webClients: 1,
    popular: false,
    tagline: 'Kick-start dashboards on a single machine',
  },
  {
    id: 'grow',
    label: 'Popular',
    name: 'Itanta Grow',
    price: 4500,
    amcRate: 0.2,
    amcAmount: 900,
    tags: 1024,
    webClients: 2,
    popular: true,
    tagline: 'Scale across departments & lines',
  },
  {
    id: 'scale',
    label: 'Advanced',
    name: 'Itanta Scale',
    price: 10500,
    amcRate: 0.2,
    amcAmount: 2100,
    tags: 4096,
    webClients: 5,
    popular: false,
    tagline: 'Full plant-site rollout',
  },
  {
    id: 'infinity',
    label: 'Enterprise',
    name: 'Itanta Infinity',
    price: 30000,
    amcRate: 0.2,
    amcAmount: 6000,
    tags: 'Unlimited',
    webClients: 20,
    popular: false,
    tagline: 'Multi-site, unlimited scale',
  },
];

export const CORE_INCLUDED_FEATURES = [
  'Dashboard Builder',
  'Drivers / Connectors',
  'User Management & RBAC',
  'Active Directory (LDAP/Windows)',
  'Formula Builder (Basic + Advanced)',
  'Unified Namespace (UNS)',
  'Shift Handling (Basic + Advanced)',
  'Email Scheduler & Themes',
  'Global Filters (Time-Based)',
];

export const CORE_ADDONS = [
  {
    id: 'web_client_pack',
    name: 'Web Client Pack',
    description: '5 additional concurrent users',
    price: 1600,
    unit: 'pack',
    maxQty: 20,
  },
  {
    id: 'formula_ai',
    name: 'Formula Builder AI',
    description: 'AI-powered formula assistance',
    price: 2700,
    unit: 'license',
    maxQty: 1,
  },
  {
    id: 'form_builder',
    name: 'Form Builder',
    description: 'Custom data-entry forms',
    price: 2700,
    unit: 'license',
    maxQty: 1,
  },
  {
    id: 'alarm_mgmt',
    name: 'Alarm Management',
    description: 'Industrial alarm tracking & logs',
    price: 2700,
    unit: 'license',
    maxQty: 1,
  },
  {
    id: 'redundancy',
    name: 'Redundancy Module',
    description: 'High-availability failover',
    price: 5000,
    unit: 'license',
    maxQty: 1,
  },
  {
    id: 'training',
    name: 'Product Training',
    description: 'Remote instructor-led session',
    price: 0,
    onRequest: true,
    unit: 'session',
    maxQty: 5,
  },
];

export const CORE_FEATURE_MATRIX = [
  { feature: 'Dashboard Builder',            start: 'included', grow: 'included', scale: 'included', infinity: 'included' },
  { feature: 'Drivers / Connectors',         start: 'included', grow: 'included', scale: 'included', infinity: 'included' },
  { feature: 'User Management & RBAC',       start: 'included', grow: 'included', scale: 'included', infinity: 'included' },
  { feature: 'Active Directory (LDAP/Win)',  start: 'included', grow: 'included', scale: 'included', infinity: 'included' },
  { feature: 'Global Filters (Time-Based)',  start: 'included', grow: 'included', scale: 'included', infinity: 'included' },
  { feature: 'Formula Builder — Basic',      start: 'included', grow: 'included', scale: 'included', infinity: 'included' },
  { feature: 'Formula Builder — Advanced',   start: 'included', grow: 'included', scale: 'included', infinity: 'included' },
  { feature: 'Unified Namespace (UNS)',      start: 'included', grow: 'included', scale: 'included', infinity: 'included' },
  { feature: 'Shift Handling — Basic',       start: 'included', grow: 'included', scale: 'included', infinity: 'included' },
  { feature: 'Shift Handling — Advanced',    start: 'included', grow: 'included', scale: 'included', infinity: 'included' },
  { feature: 'Email Scheduler',              start: 'included', grow: 'included', scale: 'included', infinity: 'included' },
  { feature: 'Themes & Styling',             start: 'included', grow: 'included', scale: 'included', infinity: 'included' },
  { feature: 'Priority Support',             start: '—',        grow: '—',        scale: '—',        infinity: 'included' },
  { feature: 'Form Builder',                 start: 'addon',    grow: 'addon',    scale: 'addon',    infinity: 'addon' },
  { feature: 'Alarm Management',             start: 'addon',    grow: 'addon',    scale: 'addon',    infinity: 'addon' },
  { feature: 'Formula Builder — AI',         start: 'addon',    grow: 'addon',    scale: 'addon',    infinity: 'addon' },
  { feature: 'Redundancy Module',            start: 'addon',    grow: 'addon',    scale: 'addon',    infinity: 'addon' },
];

// Regions (used for T&Cs, tax and price list assignment)
export const REGIONS = [
  { id: 'na',      name: 'North America' },
  { id: 'eu',      name: 'European Union' },
  { id: 'uk',      name: 'United Kingdom' },
  { id: 'nordics', name: 'Nordics' },
  { id: 'india',   name: 'India' },
  { id: 'apac',    name: 'Asia Pacific' },
  { id: 'latam',   name: 'Latin America' },
  { id: 'mea',     name: 'Middle East & Africa' },
];

// Placeholder customers (later populated from backend)
export const CORE_SAMPLE_CUSTOMERS = [
  { id: 'siemens',   name: 'Siemens Limited',     regionId: 'india', priceListId: null },
  { id: 'meml',      name: 'MEML',                regionId: 'india', priceListId: null },
  { id: 'tata',      name: 'Tata Steel',          regionId: 'india', priceListId: null },
  { id: 'novo',      name: 'Novo Nordisk',        regionId: 'nordics', priceListId: null },
  { id: 'bmw',       name: 'BMW Group',           regionId: 'eu',    priceListId: null },
  { id: 'ge',       name: 'GE Aerospace',        regionId: 'na',    priceListId: null },
];
